<template>
  <GlobalEvents
    target="window"
    @offline="_showOfflineMessage"
    @online="_showOnlineMessage"
  ></GlobalEvents>
</template>

<script>
  import GlobalEvents from 'vue-global-events';
  import eventBus from '../assets/js/event-bus';


  export default {
    name: 'NetworkStatus',

    components: {
      GlobalEvents
    },

    mounted() {
      if (!navigator.onLine) {
        this._showOfflineMessage();
      }
    },

    methods: {
      _showOfflineMessage() {
        eventBus.$emit('notifyUser', {
          message: 'Du bist offline',
          timeout: 0
        });
      },

      _showOnlineMessage() {
        eventBus.$emit('notifyUser', 'Du bist wieder online');
      }
    }
  };
</script>
